import { AfterViewInit, Directive, ElementRef, Input } from "@angular/core";

@Directive({
    selector: "[text-cut]"
})
export class TextCutDirective implements AfterViewInit {
    @Input() maxDigit: number; //grather than 3

    constructor(
        private elementRef: ElementRef
    ) { }
    ngAfterViewInit(): void {
        if (this.maxDigit) {
            const htmlElement = this.elementRef.nativeElement as HTMLElement;
            if (htmlElement.textContent.length > this.maxDigit) {
                htmlElement.textContent = htmlElement.textContent.substring(0, this.maxDigit - 3) + '...';
            }
        }
    }

}